export type FolderType = 'folder';
export type FileType = 'file';
export type UrlType = 'url';

export type FilesystemItemType = FolderType | FileType | UrlType;

export const filesystemItemType: {
  FOLDER: FolderType,
  FILE: FileType,
  URL: UrlType,
} = {
  FOLDER: 'folder',
  FILE: 'file',
  URL: 'url',
};

export enum FileAccessType {
  Private = 'private',
  Public = 'public',
}

export const FILE_ACCESS_TYPE_LABELS: Record<FileAccessType, string> = {
  [FileAccessType.Private]: 'Private',
  [FileAccessType.Public]: 'Public',
};

export interface IFilesystemListItem {
  id: number,
  name: string,
  type: FilesystemItemType,
  extension: string,
  fileAccessType?: FileAccessType,
}
